import { useCallback, useMemo } from 'react';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Typography } from '@mui/material';

import CheckboxMultipleOutline from '@/assets/icons/CheckboxMultipleOutline';
import ClearAllButton from '@/components/ClearAllButton';
import { NameInput } from '@/features/Dashboard/components/NameInput';
import { DataHubCard } from '@/features/DataHub/components/DataHubCard';
import { ItemDetails } from '@/features/DataHub/components/ItemDetails';
import PreviewAccordion from '@/features/DataHub/components/Preview/PreviewAccordion';
import {
  useExportMeta,
  useExportSettings
} from '@/features/DataHub/modules/Export/context/exportContexts';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';
import useSelectionFunctions from '@/features/SymbolSelector/hooks/useSelectionFunctions';

const ItemDetailsSection = () => {
  const { uniqueSymbols, exportName, setExportName } = useExportMeta();
  const { removeSymbolsFromSelection } = useSelectionFunctions();
  const symbols = useMemo(() => Array.from(uniqueSymbols), [uniqueSymbols]);
  const handleClearAllClick = useCallback(() => {
    removeSymbolsFromSelection(symbols);
  }, [removeSymbolsFromSelection, symbols]);
  const { exportSettings } = useExportSettings();
  return (
    <DataHubCard
      expandable={false}
      title={
        <>
          <Box
            component='span'
            sx={{
              display: 'inline-flex',
              minWidth: '100px',
              width: `${Math.max((exportName?.length ?? 0) + 0.5, 10)}ch`,
              '& .name-input': {
                flex: 'none',
                width: '100%'
              }
            }}
          >
            <NameInput
              isEmpty={exportName === ''}
              maxLength={25}
              value={exportName ?? undefined}
              onChange={value => {
                setExportName(value);
              }}
            />
          </Box>
          <EditOutlinedIcon sx={{ fontSize: '16px' }} />
        </>
      }
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}
      >
        {' '}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Typography
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
          >
            <CheckboxMultipleOutline /> {symbols.length} item{symbols.length === 1 ? '' : 's'}{' '}
            selected
          </Typography>
          <ClearAllButton onClick={handleClearAllClick} />
        </Box>
        <ItemDetails symbols={symbols} />
        {exportSettings.exportType === ExportTypes.DATA && <PreviewAccordion />}
      </Box>
    </DataHubCard>
  );
};

export default ItemDetailsSection;
